import React from "react";
import './adults.css'

const DurationofTrip = (props: any) => {
    const { node, data, change } = props;
    const updateCount = (node: any, value: any) => {
        let updateData = [...data];
        let filter: any;
        filter = updateData.filter((n: any) => {
            return n.name === node.name;
        });
        if (value >= -1) {
            if (filter[0]) {
                value === -1 ? filter[0].value = 0 : filter[0].value = value;
            }
        }
        change([...updateData])

    }
    return <div className="roomContainer">
        <div className="flex roomAction">
            <div className="nme">{node.title}</div>
            <div className="actionBox">
                <div className={node.value <= 0 ? "roomBtn disabled" : "roomBtn"} onClick={() => updateCount(node, node?.value - 1)}><div className="sub">-</div></div>
                <div className="roomCount"><div className="count">{node?.value}</div></div>
                <div className={"roomBtn"} onClick={() => updateCount(node, node?.value + 1)}><div className="sub">+</div></div>
            </div>
        </div>

    </div>
}

export default DurationofTrip